
    export const TOKEN_DEFAULT = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImFkbWluIiwic3ViIjoiNDA5OGQyMTctNzMyMy00ODhmLThmODItZWNiYTJkNjgyMWNkIiwianRpIjoiYzMyOTE4MmYtYTI5Ni00YzczLTkwYmUtZTdiZTg5OGQwNWJlIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjpbIkFETUlOIiwiUFJPQ0VTQURPUiJdLCJleHAiOjE3NTQ2MDU3MzAsImlzcyI6Imh0dHBzOi8vZGVrYWxhYi5jb20vIiwiYXVkIjoidXJuOm15LWFwaSJ9.NNY4IHJdzCanpuj7GqcVGUaZAfCKcxImg7BFKc-doeE';

    
    export function isUserAdmin() {
        // return authorization header with jwt token
        let user = JSON.parse(localStorage.getItem('user'));
        //const { user } = this.$store.state.authentication;
    
        return   user && user.username == 'admin';
    
    }

    export function isUserGuest() {
        // return authorization header with jwt token
        const user = JSON.parse(localStorage.getItem('user'));
    
        return user && user.token == TOKEN_DEFAULT;
    }